import * as React from 'react'
import classNames from 'classnames'

import { SVG_Back } from '../svg/SVG_Back'
import { SVG_Exit } from '../svg/SVG_Exit'
import { SVG_Info } from '../svg/SVG_Info'
import { SVG_Ellipsis } from '../svg/SVG_Ellipsis'

type OnClick = React.MouseEventHandler<HTMLDivElement>

export function TopBarBackButton(props: { onClick: OnClick }) {
    return (
        <div
            data-testid="top-bar-back-button"
            role="button"
            className="AppCore__page__TopBarBackButton"
            onClick={props.onClick}
        >
            <SVG_Back />
        </div>
    )
}

export function TopBarCloseButton(props: { onClick: OnClick; dataTestId?: string; dark?: boolean }) {
    return (
        <div
            className={classNames('AppCore__page__TopBarCloseButton', { dark: props.dark })}
            onClick={props.onClick}
            data-testid={props.dataTestId}
        >
            <SVG_Exit width={24} height={24} color={props.dark ? 'var(--white)' : undefined} />
        </div>
    )
}

export function TopBarSettingsButton(props: {
    onClick: OnClick
    user: { name: string; profileCircleColor: string; profileImageUrl: string }
}) {
    return (
        <div
            data-testid="top-bar-settings-button"
            className="AppCore__page__TopBarSettingsButton"
            onClick={props.onClick}
        >
            <zaptic-profile-circle
                name={props.user.name}
                color={props.user.profileCircleColor}
                profile-image-url={props.user.profileImageUrl}
            />
        </div>
    )
}

export function TopBarInfoButton(props: { color: string; onClick: OnClick }) {
    return (
        <div className="AppCore__page__TopBarInfoButton" onClick={props.onClick}>
            <SVG_Info color={props.color} />
        </div>
    )
}

export function TopBarOptionsButton(props: { onClick: OnClick }) {
    return (
        <div
            data-testid="action-page-options-button"
            className="AppCore__page__TopBarOptionsButton"
            onClick={props.onClick}
        >
            <SVG_Ellipsis />
        </div>
    )
}
